// @flow
import { useState, useCallback, useEffect } from 'react';

import { api } from 'app/api';
import { GET_KLASSES, convertResult, convertParams } from 'app/common/api/requests/cabinet/dnevnik/klasses';
import type { Klasses } from 'app/dataTypes/Klasses.types';


export default function useKlasses(studentId: string): [Klasses, boolean] {
  const [loading, setLoading] = useState(true);
  const [klasses, setKlasses] = useState<Klasses>([]);

  const handleReuest = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_KLASSES, {
      error: 'Не удалось получить данные по классам',
      params: { studentId },
      convertions: { convertParams, convertResult },
    });
    if (res) {
      setKlasses(res);
    }
    setLoading(false);
  }, [studentId]);

  useEffect(() => {
    handleReuest();
  }, [handleReuest]);

  return [klasses, loading];
}
